
export function isEmpty(val) {
    return val === null || val === undefined || validator.isEmpty(val);
}


export function dogrulaBos(deger, alan) {
    let hata = false;

    if (isEmpty(deger)) {
        hata = "Lütfen "+alan+" alanını giriniz!";
    }
    return hata;
}

/**
 * Parola dogrulaması yapar,
 * validator kütüphanesini kullanarak ve ortam ayarlarına bakarak parolayı dogrular
 * @param {string} TCKimlikNo
 * @returns {boolean|string} Hata yoksa false, hata varsa hata mesajı döner
 */
export function dogrulaTCKimlikNo(TCKimlikNo) {
    let hata = false;

    if(isEmpty(TCKimlikNo)){
        hata = 'Lütfen T.C. Kimlik numaranızı giriniz!';
    }
    else if(!validator.isNumeric(TCKimlikNo)){
        hata = 'T.C. Kimlik numarası sadece rakam olmalıdır';
    }
    else if(TCKimlikNo.length != 11) {
        hata = 'T.C. Kimlik numarası 11 karakter olmalıdır';
    }
    // pattern : "^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$",
    //     flags: "i",
    //     message : "parola en az 1 Büuük bir küçük ve bir . içermelidir"
    return hata;
}

export function capitalizeFirstLetter(str) {
    return str && str.charAt(0).toUpperCase() + str.slice(1);
}